import { useEffect } from "react";

/** Register only the tablet app's manifest and service-worker scope. */
export function useKaysouAssistPWA() {
  useEffect(() => {
    const existing = document.querySelector('link[rel="manifest"][data-kaysou-assist]');
    const link = existing || document.createElement("link");
    link.rel = "manifest";
    link.href = "/kaysou-assist-manifest.json";
    link.setAttribute("data-kaysou-assist", "true");
    if (!existing) document.head.appendChild(link);

    const theme = document.querySelector('meta[name="theme-color"][data-kaysou-assist]') || document.createElement("meta");
    theme.name = "theme-color";
    theme.content = "#030712";
    theme.setAttribute("data-kaysou-assist", "true");
    if (!theme.parentNode) document.head.appendChild(theme);

    const appleCapable = document.querySelector('meta[name="apple-mobile-web-app-capable"][data-kaysou-assist]') || document.createElement("meta");
    appleCapable.name = "apple-mobile-web-app-capable";
    appleCapable.content = "yes";
    appleCapable.setAttribute("data-kaysou-assist", "true");
    if (!appleCapable.parentNode) document.head.appendChild(appleCapable);

    const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"][data-kaysou-assist]') || document.createElement("meta");
    appleTitle.name = "apple-mobile-web-app-title";
    appleTitle.content = "Kaysou Assist";
    appleTitle.setAttribute("data-kaysou-assist", "true");
    if (!appleTitle.parentNode) document.head.appendChild(appleTitle);

    let cancelled = false;
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/kaysou-assist-sw.js", { scope: "/kaysou-assist" })
        .then(() => { if (!cancelled) console.info("[KAYSOU_ASSIST_PWA] ready"); })
        .catch((error) => console.warn("[KAYSOU_ASSIST_PWA] registration failed", error));
    }

    return () => { cancelled = true; };
  }, []);
}
